/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/statistics.scss';
import Tab from '../../component/Inc/Tab';
import LineChart from '../../component/Inc/LineChart';
import Paging from '../../component/Inc/Paging';

function Teacher() {
  const lineChartWidth = '100%';
  const lineChartHeight = '200px';
  const [isOrderActive1, setIsOrderActive1] = useState(false);//게시글 sort옵션
  //Tab Component
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '년별', value: 0},
    {title: '월별', value: 1}
  ];

  const lineChartlabels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

  const lineChartDataYearly = {
    lineChartlabels,
    datasets: [
      {
        label: '2021',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '2022',
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      },
      {
        label: '2023',
        data: [3, 4, 6, 5, 8.5, 4.85, 2, 6, 7, 9, 3, 10],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#6d747f'
      }
    ]
  };

  const lineChartDataMonthly = {
    lineChartlabels,
    datasets: [
      {
        label: '첫수업',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '취소',
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      },
      {
        label: '중단',
        data: [3, 4, 6, 5, 8.5, 4.85, 2, 6, 7, 9, 3, 10],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#6d747f'
      },
      {
        label: '인계',
        data: [1, 2.5, 3, 2.8, 2.1, 3.25, 2.4, 4, 3.7, 1.8, 4.3, 2.2],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#8f55ff'
      },
      {
        label: '종료',
        data: [4.1, 1.8, 2.1, 4.2, 3.8, 5.25, 5.85, 3.95, 6.2, 2, 3.9, 2.8],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#2bce71'
      }
    ]
  };
  return (
    <main className="com_container com_statistics p_teacher">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu10_2">담임별 영업실적</h2>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              </div>
              <section className="com_board_search">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>

            <hr className="com_divider" />
            <div className="com_calendar_wrap has_option">
              <div className="year">
                <button className="btn btn_first"></button>
                <button className="btn btn_prev"></button>
                <button className="btn_txt">2023</button>
                <button className="btn btn_next"></button>
                <button className="btn btn_last"></button>
              </div>
              <div className="com_count_wrapper">
                <div className="operators">
                  <div className="operators_label">
                    <span className="operators_count">총 영업자 수</span>
                    <span className="operators_value">98명</span>
                  </div>
                </div>
                <div className="turnover">
                  <div className="turnover_label">
                    <span className="turnover_count">총 매출액</span>
                    <span className="turnover_value">46,500,000</span>
                  </div>
                </div>
              </div>
            </div>
            {tabIdx === 0 && (
              <div className="yearly_wrapper">
                <div className="com_chart_wrap">
                  <div className="chart_body">
                    <div className="chart_name">
                      <div className="chart_item">
                        <span className="chart_name_label">2021</span>
                        <div className="chart_slider chart_orange"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">2022</span>
                        <div className="chart_slider chart_blue"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">2023</span>
                        <div className="chart_slider chart_gray"></div>
                      </div>
                    </div>
                    <div className="chart_content">
                      <LineChart data={lineChartDataYearly} width={lineChartWidth} height={lineChartHeight} />
                    </div>
                  </div>
                </div>
                <table className="com_board_list">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        순위
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        담임명
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        회차 수
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        1월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        2월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        3월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        4월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        5월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        6월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        7월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        8월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        9월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        10월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        11월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        12월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        매출합
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>김영업103</td>
                      <td>3214</td>
                      <td>4568,000</td>
                      <td className="highlight">57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td className="td_point">8000,000</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>김영업103</td>
                      <td>3214</td>
                      <td>4568,000</td>
                      <td className="highlight">57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td className="td_point">8000,000</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>김영업103</td>
                      <td>3214</td>
                      <td>4568,000</td>
                      <td className="highlight">57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td className="td_point">8000,000</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>김영업103</td>
                      <td>3214</td>
                      <td>4568,000</td>
                      <td className="highlight">57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td className="td_point">8000,000</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>김영업103</td>
                      <td>3214</td>
                      <td>4568,000</td>
                      <td className="highlight">57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td className="td_point">8000,000</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>김영업103</td>
                      <td>3214</td>
                      <td>4568,000</td>
                      <td className="highlight">57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td>4568,000</td>
                      <td>57,000</td>
                      <td className="td_point">8000,000</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td colSpan="2">2023</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point"> 3,150,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">654,654,000</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td colSpan="2">2022</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>1,057,000</td>
                    </tr>

                    <tr className="summarized_rows">
                      <td colSpan="2">증감율</td>
                      <td className="td_red">
                        <span className="arrow_blue">654</span>
                      </td>
                      <td className="td_red">
                        <span className="arrow_blue">3214</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">3214</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Paging />
              </div>
            )}

            {tabIdx === 1 && (
              <div className="monthly_wrapper">
                <div className="com_chart_wrap">
                  <div className="chart_body">
                    <div className="chart_name">
                      <div className="chart_item">
                        <span className="chart_name_label">첫수업</span>
                        <div className="chart_slider chart_orange"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">취소</span>
                        <div className="chart_slider chart_blue"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">중단</span>
                        <div className="chart_slider chart_gray"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">인계</span>
                        <div className="chart_slider chart_indigo"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">종료</span>
                        <div className="chart_slider chart_green"></div>
                      </div>
                    </div>
                    <div className="chart_content">
                      <LineChart data={lineChartDataMonthly} width={lineChartWidth} height={lineChartHeight} />
                    </div>
                  </div>
                </div>

                <table className="com_board_list">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                    <col width="{{ width: 'calc(100% / 19)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        순위
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        담임명
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        회차 수
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>등록 학생수</th>
                      <th>국어</th>
                      <th>영어</th>
                      <th>수학</th>
                      <th>과탐</th>
                      <th>사탐</th>
                      <th>논술</th>
                      <th>수시</th>
                      <th>
                        첫 수업
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        첫 달 과목추가
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        취소
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        중단
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        인계
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        종료
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        총 매출액
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        총 입금액
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>김영업103</td>
                      <td>3214</td>
                      <td>12</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>45</td>
                      <td>2</td>
                      <td>4</td>
                      <td>2</td>
                      <td>3</td>
                      <td>7</td>
                      <td className="td_point">6547,000</td>
                      <td className="td_point">8000,000</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>김영업103</td>
                      <td>3214</td>
                      <td>12</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>45</td>
                      <td>2</td>
                      <td>4</td>
                      <td>2</td>
                      <td>3</td>
                      <td>7</td>
                      <td className="td_point">6547,000</td>
                      <td className="td_point">8000,000</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>김영업103</td>
                      <td>3214</td>
                      <td>12</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>45</td>
                      <td>2</td>
                      <td>4</td>
                      <td>2</td>
                      <td>3</td>
                      <td>7</td>
                      <td className="td_point">6547,000</td>
                      <td className="td_point">8000,000</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>김영업103</td>
                      <td>3214</td>
                      <td>12</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>45</td>
                      <td>2</td>
                      <td>4</td>
                      <td>2</td>
                      <td>3</td>
                      <td>7</td>
                      <td className="td_point">6547,000</td>
                      <td className="td_point">8000,000</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>김영업103</td>
                      <td>3214</td>
                      <td>12</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>45</td>
                      <td>2</td>
                      <td>4</td>
                      <td>2</td>
                      <td>3</td>
                      <td>7</td>
                      <td className="td_point">6547,000</td>
                      <td className="td_point">8000,000</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>김영업103</td>
                      <td>3214</td>
                      <td>12</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>45</td>
                      <td>2</td>
                      <td>4</td>
                      <td>2</td>
                      <td>3</td>
                      <td>7</td>
                      <td className="td_point">6547,000</td>
                      <td className="td_point">8000,000</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td colSpan="2">2023</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point"> 3,150,000</td>
                      <td className="td_point">142</td>
                      <td className="td_point">142</td>
                      <td className="td_point">142</td>
                      <td className="td_point">142</td>
                      <td className="td_point">142</td>
                      <td className="td_point">142</td>
                      <td className="td_point">142</td>
                      <td className="td_point">32134</td>
                      <td className="td_point">32134</td>
                      <td className="td_point">32134</td>
                      <td className="td_point">32134</td>
                      <td className="td_point">32134</td>
                      <td className="td_point">32134</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">654,654,000</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td colSpan="2">2022</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>142</td>
                      <td>142</td>
                      <td>142</td>
                      <td>142</td>
                      <td>142</td>
                      <td>142</td>
                      <td>142</td>
                      <td>31</td>
                      <td>31</td>
                      <td>312</td>
                      <td>312</td>
                      <td>312</td>
                      <td>312</td>
                      <td>547,000</td>
                      <td>1,057,000</td>
                    </tr>

                    <tr className="summarized_rows">
                      <td colSpan="2">증감율</td>
                      <td className="td_red">
                        <span className="arrow_blue">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">3214</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">547,000</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">547,000</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">547,000</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">3214</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Paging />
              </div>
            )}
          </div>
        </section>
      </div>
    </main>
  );
}

export default Teacher;
